import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import { TextArea } from "@progress/kendo-react-inputs";

export const AdministratorMarkOrdersAsPaid = (props) => {
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [orderIdsString, setOrderIdsString] = useState("");

    const markOrdersAsPaid = () => {
        if (!orderIdsString) {
            addNotificationWithTimeout(dispatch, "error", "You must enter order Ids");
            return;
        }

        const orderIds = orderIdsString.split("\n");

        if (orderIds.length === 0) {
            addNotificationWithTimeout(dispatch, "error", "You must enter real order Ids");
            return;
        }

        if (window.confirm("Are you sure you want to mark these orders as paid?") === false) {
            return;
        }

        setIsLoading(true);

        const dataItem = {
            orderIds: orderIds,
        }

        fetch("/api/administrator/pos/markordersaspaid",
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setIsLoading(false);

                addNotificationWithTimeout(dispatch, "success", "Marked orders as paid successfully");

                setOrderIdsString("");
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setIsLoading(false);
            });
    }

    const orderIdsChanged = (event) => {
        const value = event.value;
        setOrderIdsString(value);
    };

    useEffect(() => {
        document.title = "Mark Orders As Paid";
    }, []);

    return (
        <div className="p-3">
            <div className="mb-3">
                <Label>Order Ids (one per line):</Label>

                <div className="row">
                    <div className="col">
                        <TextArea
                            id={"orderIds"}
                            name={"orderIds"}
                            value={orderIdsString}
                            onChange={orderIdsChanged}
                            rows={20}
                        />
                    </div>
                </div>

                <Button
                    themeColor={"primary"}
                    type={"button"}
                    onClick={markOrdersAsPaid}
                    className="mt-2"
                >
                    Mark Orders As Paid
                </Button>
            </div>

            {isLoading ? <LoadingPanel /> : <></>}
        </div>
    );
}